import React  from 'react'
import { GetTemplates } from '../../../api/services/shared';
import DropDown from '../dropdown';

const TemplatesDropDown = ({...rest}) => {
    return <DropDown api={GetTemplates} textField="Name" valueField="Id" labelField="LanguageName" descriptionField={item=>{
        return <span style={{padding: "0.5833em 0.833em"}}>{item.TypeName}</span>
    }} {...rest}/> 
}

export default TemplatesDropDown